package demos.buttons

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.animateIntAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.material.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Star
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.BlurredEdgeTreatment
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.blur
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlin.math.roundToInt


const val RATING_BUTTON = "87b13b94fb07668e5c9166e918db2abd339578aea8d7e2d8efd5c0ffb7e820aa"



val yellow = Color(0xFFf0e54a)

@Composable
fun RatingView() {

    var rating by remember { mutableStateOf(5) }

    RatingStars(
        modifier = Modifier,
        rating = rating,
        onRatingSelected = {
            rating = it
        }
    )
}

@Composable
fun RatingStars(
    modifier: Modifier = Modifier,
    rating: Int,
    onRatingSelected: (Int) -> Unit,
) {

    Row(
        modifier = modifier
    ) {

        val animatedRating by animateIntAsState(
            targetValue = rating,
            animationSpec = tween(
                durationMillis = 150,
                easing = LinearEasing,
            )
        )

        for (i in 1..5) {
            val starActive = when {
                animatedRating >= i -> 1f
                else -> 0f
            }
            val animatedScale by animateFloatAsState(
                targetValue = starActive,
                animationSpec = spring(
                    stiffness = Spring.StiffnessMediumLow,
                    dampingRatio = when (starActive) {
                        0f -> Spring.DampingRatioNoBouncy
                        else -> Spring.DampingRatioMediumBouncy
                    }

                ),
                label = "single star"
            )

            val interactionSource = remember { MutableInteractionSource() }
            val isHovered by interactionSource.collectIsHoveredAsState()

            val hoverBounce by animateFloatAsState(
                targetValue = if (isHovered) -15f else 0f,
                animationSpec = spring(
                    stiffness = Spring.StiffnessMedium,
                )
            )

            Box(
                modifier = Modifier
                    .hoverable(interactionSource)
                    .offset {
                        IntOffset(0, hoverBounce.roundToInt())
                    }
                    .pointerInput(Unit) {
                        detectTapGestures {
                            onRatingSelected(i)
                        }
                    },
                contentAlignment = Alignment.Center,
            ) {
                Icon(
                    painter = rememberVectorPainter(image = Icons.Rounded.Star),
                    contentDescription = null,
                    modifier = Modifier
                        .size(56.dp)
                        .alpha(.1f),
                )
                Icon(
                    painter = rememberVectorPainter(image = Icons.Rounded.Star),
                    contentDescription = null,
                    modifier = Modifier
                        .blur(30.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                        .size(56.dp)
                        .scale(animatedScale),
                    tint = yellow.copy(alpha = .4f)
                )
                Icon(
                    painter = rememberVectorPainter(image = Icons.Rounded.Star),
                    contentDescription = null,
                    modifier = Modifier
                        .size(56.dp)
                        .scale(animatedScale),
                    tint = yellow
                )
                Icon(
                    painter = rememberVectorPainter(image = Icons.Rounded.Star),
                    contentDescription = null,
                    modifier = Modifier
                        .scale(animatedScale)
                        .offset(2.dp, 2.dp)
                        .size(56.dp),
                    tint = yellow.copy(alpha = .4f)
                )
            }
        }
    }
}